import styled from 'styled-components';
import { mixins } from '../../../css';
import NavLink from '../common/NavLink';

export const DesktopWrapper = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: ${mixins.pxToRem(80)};
  margin: 0 auto;
`;

export const HomeLinkContainer = styled.div`
  width: ${mixins.pxToRem(165)};
  height: 100%;
  padding: 0 ${mixins.pxToRem(20)};
  margin-left: ${mixins.pxToRem(60)};
`;

export const TopNavIcon = styled.div`
  padding: ${mixins.pxToRem(15)} ${mixins.pxToRem(25)};
  cursor: pointer;

  figure {
    cursor: pointer !important;
  }
`;

export const SideNavIcon = styled(TopNavIcon)`
  position: absolute;
  top: ${mixins.pxToRem(13)};
  left: 0;
`;

export const Spacer = styled.div`
  flex-grow: 1;
`;

export const MenuContainer = styled.div`
  width: ${mixins.pxToRem(160)};
  height: 100%;
`;

export const NotificationContainer = styled.div`
  margin-right: ${mixins.pxToRem(15)};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;

  .label {
    margin-left: ${mixins.pxToRem(20)};
  }

  &:hover {
    ${({ theme }) => `color: ${theme.lightTheme}`};
  }
`;
